export function checklistItems(onboarding) {
  return [
    {
      icon: 'event',
      label: 'Agendar primeira sessão',
      done: onboarding.hasSession,
      route: '/agenda',
    },
    {
      icon: 'link',
      label: 'Enviar ficha digital',
      done: onboarding.hasSelfRegistration,
      route: '/clientes',
    },
    {
      icon: 'graphic_eq',
      label: 'Transcrever uma sessão',
      done: onboarding.hasTranscription,
      route: '/agenda',
    },
  ]
}
